import { createRouter, createWebHistory } from "vue-router";
import Profile from "../views/Profile.vue";
import Login from "../views/examples-api/Login.vue";
import Signup from "../views/examples-api/Signup.vue";
import PasswordForgot from "../views/examples-api/PasswordForgot.vue";
import PasswordReset from "../views/examples-api/PasswordReset.vue";
import UserProfile from "../views/examples-api/profile/UserProfile.vue";
import Users from "../views/examples-api/users/UsersList.vue";
import Users1 from "../views/Users1.vue";
import AddUser from "../views/AddUser.vue";
import Vbots from "../views/Vbots.vue";
import AddVbot from "../views/AddVbot.vue";
import ChangePassword from "../views/ChangePassword.vue";
import EditUser from "../views/EditUser.vue";
import EditVbot from "../views/EditVbot.vue";
import Phonebots from "../views/Phonebots.vue";
import EditPhonebot from "../views/EditPhonebot.vue";
import MyProfile from "../views/MyProfile.vue";
import ViewCallLogs from "../views/ViewCallLogs.vue";
import store from "@/store";
import CustomerList from "../views/CustomerList.vue";
import EditCustomer from "../views/EditCustomer.vue";
import CompletedLogs from "../views/CompletedLogs.vue";
import Guest from "../views/Guest.vue";
import EditGuest from "../views/EditGuest.vue";
import CallsCount from "../views/CallsCount.vue";
import EditVbotByGuest from "../views/EditVbotByGuest.vue";
import VbotsForGuest from "../views/VbotsForGuest.vue";
import Company from '@/views/Company.vue';
import NewCalls from "../views/NewCalls.vue";
import FinishSignup from "../views/examples-api/FinishSignup.vue";
import AdminCallLogs from "../views/ViewCallLogsAdmin.vue"; // NEW: Admin Call Logs View

  
const routes = [
  
  {
    path: "/",
    name: "/",
    redirect: "/login",
  },
  {
    path: "/users1",
    name: "users1",
    component: Users1,
    meta: {
      authRequired: true,
     
    }
  },
  {
    path: "/finish-signup",
    name: "FinishSignup",
    component: FinishSignup,
  },
  {
    path: "/addusers",
    name: "addusers",
    component: AddUser,
    meta: {
      authRequired: true,
     
    }
  },
  {
    path: '/edituser/:data',
    name: 'EditUser',
    component: EditUser,
    meta: {
      authRequired: true,
     
    }
   
  },
  {
    path: '/newcalls',
    name: 'NewCalls',
    component: NewCalls,
    meta: {
      authRequired: true,
    }
  },
  {
    path: '/editcustomer/:id',
    name: 'EditCustomer',
    component: EditCustomer,
    meta: {
      authRequired: true,
     
    }
   
  },
  {
    path: "/vbots",
    name: "vbots",
    component: Vbots,
    meta: {
      authRequired: true,
     
    }
  },
  {
    path: "/vbotsforGuest",
    name: "vbotsForGuest",
    component: VbotsForGuest,
    meta: {
      authRequired: true,
     
    }
  },
  {
    path: "/phonebots",
    name: "phonebots",
    component: Phonebots,
    meta: {
      authRequired: true,
     
    }
  },
  {
    path: '/editvbot/:license_Key',
    name: 'EditVbot',
    component: EditVbot,
    meta: {
      authRequired: true,
     
    }
   
  },
  {
    path: '/vbotbyguest/:license_Key',
    name: 'EditVbotByGuest',
    component: EditVbotByGuest,
    meta: {
      authRequired: true,
     
    }
   
  },
  {
    path: '/viewcalllogs',
    name: 'ViewCallLogs',
    component: ViewCallLogs,
    meta: {
      authRequired: true,
     
    }
   
  },
  // NEW: Admin Call Logs Route for Superadmin (uses query params, not URL params)
  {
    path: '/admin/calllogs',
    name: 'AdminCallLogs',
    component: AdminCallLogs,
    meta: {
      authRequired: true,
      requiresRole: 'super'
    }
  },
  {
    path: '/editphonebot/:license_Key',
    name: 'EditPhonebot',
    component: EditPhonebot,
    meta: {
      authRequired: true,
     
    }
   
  },
  {
    path: "/addvbot",
    name: "addvbot",
    component: AddVbot,
    meta: {
      authRequired: true,
     
    }
  },
  {
    path: "/changepassword",
    name: "changepassword",
    component: ChangePassword,
    meta: {
      authRequired: true,
     
    }
  },
  {
    path: "/myprofile",
    name: "myprofile",
    component: MyProfile,
    meta: {
      authRequired: true,
     
    }
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
  },
  {
    path: "/login",
    name: "Login",
    component: Login
  },
  {
    path: "/signup",
    name: "Signup",
    component: Signup
  },
  {
    path: "/password-forgot",
    name: "Password Forgot",
    component: PasswordForgot
  },
  {
    path: "/password-reset",
    name: "Password Reset",
    component: PasswordReset
  },
  {
    path: "/user-profile",
    name: "User Profile",
    component: UserProfile
  },
  {
    path: '/users',
    name: "Users",
    component: Users
  },
  {
    path: '/customers',
    name: "customers",
    component: CustomerList,
    meta: {
      authRequired: true,
     
    }
  },
  {
    path: '/guest',
    name: "Guest",
    component: Guest,
    meta: {
      authRequired: true,
     
    }
  },
  {
    path: '/editguest/:id',
    name: 'EditGuest',
    component: EditGuest,
    meta: {
      authRequired: true,
     
    }
   
  },
  {
    path: '/completed',
    name: "completed",
    component: CompletedLogs,
    meta: {
      authRequired: true,
     
    }
  },
  {
    path: '/callsCount',
    name: "callsCount",
    component: CallsCount,
    meta: {
      authRequired: true,
     
    }
  },
  {
    path: '/company',
    name: 'Company',
    component: Company,
    meta: { 
      requiresAuth: true,
      requiresRole: 'admin' // Nur für Admins
    }
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

//eslint-disable-next-line no-unused-vars
router.beforeEach(async (to, from, next) => {

  const { authRequired, permission } = to.meta;

  const isLoggedIn = store.getters['auth/isLoggedIn'];

  if (authRequired) {

    //if trying to access a page that requires authentication but not logged in, redirect to login page
    if (!isLoggedIn) {
      return next({ name: 'Login', query: { returnUrl: to.path } });
    }


    //if trying to access a page that requires permission, redirect to dashboard
    if (permission) {
      try {
        await store.dispatch('profile/getProfile')
        const userPermission = (store.getters['profile/getUserProfile']).roles[0].name;
        if (!permission.includes(userPermission)) {
          return next({ name: 'Default', query: { returnUrl: to.path } });
        }
      }catch(error){
        try{
          store.dispatch('auth/logout');
        }finally{
          // eslint-disable-next-line no-unsafe-finally
          return next({name: "Login"});
        }
      }
    }

  }
  next();
})

export default router;